import { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/icon/icon';
import 'components/site-message/site-message.scss';

class SiteMessage extends Component {
    render() {
        return (
            <div className={`bk-site-message ${this.props.isOpen ? 'open' : ''}`}>
                <div>
                    {this.props.content}
                    {this.props.buttons}
                    {this.props.dismissable && <Icon icon="x" onClick={() => this.props.onClose()} />}
                </div>
            </div>
        );
    }
}

SiteMessage.propTypes = {
    content: PropTypes.node,
    buttons: PropTypes.arrayOf(PropTypes.node),
    dismissable: PropTypes.bool,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
};

export default SiteMessage;
